<div class="text-center">
    <p class="mb-3 text-sm font-semibold">You are not authorized to use this application</p>
    <button type="button" class="mr-0 btn btn-primary" (click)="onLogout()">Logout</button>
</div>